export default "<p>evento-detalhe-dashboard works!</p>\r\n";